import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import { flex, colors } from '../../constants/style'

import Logo from '../Logo'

import { MenuButton } from '../UI/Button'
import { Row } from '../UI/Grid'

const Wrapper = styled.div`
  background-color: white;
  border-bottom: 1px solid ${({ sticky }) => (sticky ? colors.gray : 'transparent')};
  height: 110px;
  left: 0;
  padding: 20px 40px;
  position: ${({ sticky }) => (sticky ? 'fixed' : 'absolute')};
  right: 0;
  top: ${({ sticky }) => (sticky ? '0' : '100%')};
  transition: box-shadow .3s ease-in-out;
  z-index: 100;
`

class StickyHeader extends Component {
  state = {
    sticky: false
  }

  calculateStickyState = () => {

    if (this._rafExecuting) {
      return
    }

    this._rafExecuting = true

    requestAnimationFrame(() => {

      const scrollTop = (window.pageYOffset !== undefined)
        ? window.pageYOffset :
        (document.documentElement || document.body.parentNode || document.body).scrollTop

      if (scrollTop >= this.wrapperOffsetTop && !this.state.sticky) {
        this.setState({ sticky: true }, () => {
          this.props.onSticky(true)
        })
      } else if (scrollTop < this.wrapperOffsetTop && this.state.sticky) {
        this.setState({ sticky: false }, () => {
          this.props.onSticky(false)
        })
      }

      this._rafExecuting = false
    })
  }

  saveTopWrapper = () => this.wrapperOffsetTop = this.wrapper.offsetTop

  componentDidMount() {
    window.addEventListener('scroll', this.calculateStickyState)
    this.saveTopWrapper()
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.calculateStickyState)
  }

  render() {
    const { sticky } = this.state
    const { onMenuClick } = this.props

    return (
      <Wrapper innerRef={node => this.wrapper = node} sticky={sticky}>
        <Row align={flex.align.CENTER} justify={flex.justify.SPACE_BETWEEN}>
          <Logo colored xsmall />
          <MenuButton onClick={onMenuClick} red />
        </Row>
      </Wrapper>
    )
  }
}

StickyHeader.defaultProps = {
  onSticky: () => {},
}

StickyHeader.propTypes = {
  onMenuClick: PropTypes.func.isRequired,
  onSticky: PropTypes.func,
}

export default StickyHeader



// WEBPACK FOOTER //
// ./src/components/StickyHeader/index.js